import { useCallback, useEffect, useState } from 'react';
import { fetchSession, type SessionInfo } from './TokenProvider';

export function useSession() {
  const [session, setSession] = useState<SessionInfo | null>(null);
  const reload = useCallback(() => {
    fetchSession().then(setSession);
  }, []);
  useEffect(reload, [reload]);
  return { session, reload };
}
